"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Add = Add;
exports.Mul = Mul;
exports.addTreeListLabel = addTreeListLabel;
exports.addTreeListLabelForCasCard = addTreeListLabelForCasCard;
exports.clearTreeData = clearTreeData;
exports.cosContent = cosContent;
exports.cosUrl = cosUrl;
exports.getTableHeight = getTableHeight;
exports.replaceImgSrcHttps = replaceImgSrcHttps;
exports.setDomain = setDomain;
exports.uploadImage = uploadImage;
var _store = _interopRequireDefault(require("@/store"));
var _systemSetting = require("@/api/system/systemSetting");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 根据需求过滤掉treeData中的child.length === 0的数据
 * @param treeData
 * @returns {Uint8Array | BigInt64Array | any[] | Float64Array | Int8Array | Float32Array | Int32Array | Uint32Array | Uint8ClampedArray | BigUint64Array | Int16Array | Uint16Array}
 */
function clearTreeData(treeData) {
  return treeData.map(function (item) {
    if (item.child.length === 0) {
      delete item.child;
    } else {
      clearTreeData(item.child);
    }
    return item;
  });
}
/**
 * 上传图片、视频
 * @param formData
 * @param data
 */
function uploadImage(formData, data) {
  return new Promise(function (resolve, reject) {
    (0, _systemSetting.fileImageApi)(formData, data).then(function (res) {
      // Message.success('上传成功');
      return resolve(res);
    }).catch(function (res) {
      reject();
    });
  });
}
function addTreeListLabel(treeData) {
  // 因树形控件在slot-scope模式下显示字段只能为label为此自定义添加label字段和child=children
  return treeData.map(function (item) {
    if ((item.name === '设置' || item.name === '管理员列表' || item.name === '身份管理' || item.name === '管理权限' || item.name === '管理员列表' || item.name === '权限规则') && _store.default.getters.name !== 'admin') {
      item.disabled = true;
    }
    item.label = item.name;
    return item;
  });
}
function addTreeListLabelForCasCard(treeData, child) {
  treeData.map(function (item) {
    if ((item.name === '设置' || item.name === '管理员列表' || item.name === '身份管理' || item.name === '管理权限' || item.name === '管理员列表' || item.name === '权限规则') && _store.default.getters.name !== 'admin') {
      item.disabled = true;
    }
    item.label = item.name;
    return item;
  });
}

//加法函数，用来得到精确的加法结果
//说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
//调用：$h.Add(arg1,arg2)
//返回值：arg1加上arg2的精确结果
function Add(arg1, arg2) {
  arg2 = parseFloat(arg2);
  var r1, r2, m;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(100, Math.max(r1, r2));
  return (this.Mul(arg1, m) + this.Mul(arg2, m)) / m;
}

//乘法函数，用来得到精确的乘法结果
//说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
//调用：$h.Mul(arg1,arg2)
//返回值：arg1乘以arg2的精确结果
function Mul(arg1, arg2) {
  arg1 = parseFloat(arg1);
  arg2 = parseFloat(arg2);
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {}
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}

//替换安全域名
function setDomain(url) {
  url = url ? url.toString() : '';
  // 正则替换存在的转义符
  url = url.replace(/\\/g, '');
  url = window.location.protocol === 'https:' ? url.replace('http://', 'https://') : url;
  if (url.startsWith('src="')) {
    url = url.replaceAll('src="', '');
  }
  if (url.startsWith('//img') && window.location.protocol === 'https:') {
    url = url.replace('//img', 'https://img');
  }
  return url;
}

// 过滤富文本中的 img 相对路径访问
function replaceImgSrcHttps(content) {
  return content.replaceAll('src="//', 'src="https://');
}

// COS 存储桶域名
var COS_DOMAIN = 'https://newsundevia-1257895785.cos.ap-guangzhou.myqcloud.com';

/**
 * 拼接 COS 完整路径（单个图片路径）
 * 空值返回''，已有http直接返回，相对路径自动拼接COS域名，重复拼接自动去重
 */
function cosUrl(path) {
  if (!path) return '';
  // 去除重复拼接的域名
  while (path.indexOf(COS_DOMAIN + '/' + COS_DOMAIN) !== -1) {
    path = path.replace(COS_DOMAIN + '/', '');
  }
  if (path.indexOf(COS_DOMAIN) === 0) return path;
  if (/^https?:\/\//i.test(path)) return path;
  var base = COS_DOMAIN + '/';
  var realPath = path.startsWith('/') ? path.substring(1) : path;
  return base + realPath;
}

/**
 * 处理富文本content中的图片相对路径，自动拼接COS域名
 */
function cosContent(content) {
  if (!content) return '';
  var base = COS_DOMAIN + '/';
  return content.replace(/src="(?!http|data:)([^"]+)"/g, "src=\"".concat(base, "$1\""));
}

/**
 *计算table固定高度
 */
function getTableHeight(height) {
  var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
  var herderHeight = 100;
  var footerHeight = 20;
  return windowHeight - herderHeight - footerHeight - height;
}